let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwqiT")).then(() => parcelRequire('kIBLO'));